/**
 * The key a browser tab keeps for connecting integrations: only the tab that started a connect can
 * finish it. Someone sent a callback link opens it in a new tab, which has no key. It never leaves
 * this tab except to LATO's API, at the start and at the finish.
 */
const STORAGE_KEY = "lato.connectTabKey";

/**
 * The key a start in this tab sends. One per tab, made on its first connect: a second start before
 * the first has left the page (another card's Connect) mustn't replace the key the first parked.
 */
export function connectTabKeyForStart(): string {
  const kept = connectTabKey();
  if (kept) return kept;
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const key = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  try {
    sessionStorage.setItem(STORAGE_KEY, key);
  } catch {
    // Without storage the finish is refused, and the finish page says to connect again.
  }
  return key;
}

/** The key of the connect this tab started, or "" if it started none. */
export function connectTabKey(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}
